/**
 * 指标相关的通用方法
 */
import { MemoryInfo } from '@vueuse/core';
/**
 * 获取PerformanceAPI
 */
export function getBrowserPerformanceAPI(): Performance | undefined {
  return window && window.performance;
}

/**
 * 通过PerformanceAPI获取当前上下文中的memory信息
 */
export function getMemoryInfo(): MemoryInfo | undefined {
  // @ts-ignore
  return getBrowserPerformanceAPI()?.memory;
}

/**
 * 获取当前issue弹窗的状态
 * @return open: 表示当前弹窗是开启状态 close： 表示当前弹窗是关闭状态
 */
export function getIssueOpenState(): IssueOpenState {
  const issueDialog = document?.querySelector('.issue-detail');
  if (!issueDialog) {
    return IssueOpenState.closed;
  }
  // 这里如果后续还有其他状态就在相应的枚举中增加
  return IssueOpenState.open;
}

/**
 * IssueOpenState
 */
export enum IssueOpenState {
  // eslint-disable-next-line no-unused-vars
  open = 'open',
  // eslint-disable-next-line no-unused-vars
  closed = 'closed'
}

/**
 * Issue 追踪属性
 */
export interface IssueTracingOptions {
  /**
   * 是否上报当前issue的状态（open， close）
   */
  reportIssueState?: boolean;
}

/**
 * 获取当前系统支持的RAF方法
 */
// eslint-disable-next-line no-unused-vars
export function getRAF(): (callback: any) => number {
  return (
    window.requestAnimationFrame ||
    // @ts-ignore
    window.webkitRequestAnimationFrame ||
    function (callback) {
      return window.setTimeout(callback, 1000 / 60);
    }
  );
}

/**
 * 获取当前环境的上下文对象
 */
// eslint-disable-next-line no-undef
export function getContext(): WindowOrWorkerGlobalScope | undefined {
  if (window) {
    return window;
  }
  if (typeof self !== 'undefined' && self) {
    return self;
  }
  return undefined;
}
